import { render, staticRenderFns } from "./PoiCardMedia.vue?vue&type=template&id=5769a23b&"
import script from "./PoiCardMedia.vue?vue&type=script&lang=ts&"
export * from "./PoiCardMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports